import megazoneVideo from '../assets/video/Megazone.mp4';
import megazoneLogo from '../assets/img/Megazone.svg';

import footballVideo from '../assets/video/Football.mp4';
import footballLogo from '../assets/img/FC_Team.svg';

import ilichVideo from '../assets/video/ilich.mp4';
import ilichLogo from '../assets/img/ilich.svg';

import remoteVideo from '../assets/video/remote.mp4';
import payLogo from '../assets/img/remote-assistence.svg';



const megazone = {
    id: 1,
    video: megazoneVideo,
    logo: megazoneLogo,
    smallHeader: 'portfolio.megaZone.smallHeader',
    mainText: 'portfolio.megaZone.mainText',
    color: 'background: linear-gradient(180deg, #379AE1 0%, #37CDE1 100%)',
    list: {
        platform: {
            name: "portfolio.megaZone.list.platform.name",
            text: "iOS / Android",
        },
        Technology: {
            name: "portfolio.megaZone.list.Technology.name",
            text: "portfolio.megaZone.list.Technology.text",
        },
        Team: {
            id: "team",
            name: "portfolio.megaZone.list.Team.name",
            text: {
                "1": "portfolio.megaZone.list.Team.text.1",
                "2": "portfolio.megaZone.list.Team.text.2",
                "3": "portfolio.megaZone.list.Team.text.3",
                "4": "portfolio.megaZone.list.Team.text.4",
                "5": "portfolio.megaZone.list.Team.text.5"
            }
        },
        Duration: {
            name: "portfolio.megaZone.list.Duration.name",
            text: "portfolio.megaZone.list.Duration.text",
        },
        Client: {
            name: "portfolio.megaZone.list.Client.name",
            text: "portfolio.megaZone.list.Client.text",
        },
    },
};

const football = {
    id: 2,
    video: footballVideo,
    logo: footballLogo,
    smallHeader: 'portfolio.football.smallHeader',
    mainText: 'portfolio.football.mainText',
    color: 'background: linear-gradient(44.13deg, #00C2FF -26.75%, #F5BB26 61.23%)',
    list: {
        platform: {
            name: "portfolio.football.list.platform.name",
            text: "iOS / Android",
        },
        Technology: {
            name: "portfolio.football.list.Technology.name",
            text: "portfolio.football.list.Technology.text",
        },
        Team: {
            id: "team",
            name: "portfolio.football.list.Team.name",
            text: {
                "1": "portfolio.football.list.Team.text.1",
                "2": "portfolio.football.list.Team.text.2",
                "3": "portfolio.football.list.Team.text.3",
                "4": "portfolio.football.list.Team.text.4",
                "5": "portfolio.football.list.Team.text.5"
            }
        },
        Duration: {
            name: "portfolio.football.list.Duration.name",
            text: "portfolio.football.list.Duration.text",
        },
        Client: {
            name: "portfolio.football.list.Client.name",
            text: "portfolio.football.list.Client.text",
        },
    },
};

const ilichRealty = {
    id: 3,
    video: ilichVideo,
    logo: ilichLogo,
    smallHeader: 'portfolio.ilichRealty.smallHeader',
    mainText: 'portfolio.ilichRealty.mainText',
    color: 'background: linear-gradient(216.43deg, #F87B21 14.77%, #853067 97.86%)',
    list: {
        platform: {
            name: "portfolio.ilichRealty.list.platform.name",
            text: "iOS / Android",
        },
        Technology: {
            name: "portfolio.ilichRealty.list.Technology.name",
            text: "portfolio.ilichRealty.list.Technology.text",
        },
        Team: {
            id: "team",
            name: "portfolio.ilichRealty.list.Team.name",
            text: {
                "1": "portfolio.ilichRealty.list.Team.text.1",
                "2": "portfolio.ilichRealty.list.Team.text.2",
                "3": "portfolio.ilichRealty.list.Team.text.3",
                "4": "portfolio.ilichRealty.list.Team.text.4",
                "5": "portfolio.ilichRealty.list.Team.text.5"
            }
        },
        Duration: {
            name: "portfolio.ilichRealty.list.Duration.name",
            text: "portfolio.ilichRealty.list.Duration.text",
        },
        Client: {
            name: "portfolio.ilichRealty.list.Client.name",
            text: "portfolio.ilichRealty.list.Client.text",
        },
    },
};

const payControl = {
    id: 4,
    video: remoteVideo,
    logo: payLogo,
    smallHeader: 'WebRTC Assistance',
    mainText: 'portfolio.payControl.mainText',
    color: 'background: linear-gradient(19.1deg, #20A13E -12.71%, #FFE600 96.18%)',
    list: {
        platform: {
            name: "portfolio.payControl.list.platform.name",
            text: "iOS / Android",
        },
        Technology: {
            name: "portfolio.payControl.list.Technology.name",
            text: "portfolio.payControl.list.Technology.text",
        },
        Team: {
            id: "team",
            name: "portfolio.payControl.list.Team.name",
            text: {
                "1": "portfolio.payControl.list.Team.text.1",
                "2": "portfolio.payControl.list.Team.text.2",
                "3": "portfolio.payControl.list.Team.text.3",
                "4": "portfolio.payControl.list.Team.text.4",
                "5": "portfolio.payControl.list.Team.text.5"
            }
        },
        Duration: {
            name: "portfolio.payControl.list.Duration.name",
            text: "portfolio.payControl.list.Duration.text",
        },
        Client: {
            name: "portfolio.payControl.list.Client.name",
            text: "portfolio.payControl.list.Client.text",
        },
    },
};

const potrfolio = {
    megazone: {
        id: 'megazone',
        item: megazone,
    },
    football: {
        id: 'football',
        item: football,
    },
    ilichRealty: {
        id: 'ilichRealty',
        item: ilichRealty,
    },
    payControl: {
        id: 'payControl',
        item: payControl,
    },
};

export default potrfolio;